import { combineReducers } from 'redux';

// import auditLog from './auditLog';
import invoices from "../../invoices/invoices-reducers";
import deliveryNotes from "../../delivery-notes/delivery-notes-reducers";
import clients from "../../clients/clients-reducers";
import executions from '../../executions/executions-reducers';
import users from "../../users/users-reducers";
import content from "../../content/content-reducers";
import technicalsSheets from "../../technical-sheets/technicals-sheets-reducers";
import stocks from "../../stocks/stocks-reducers";
import audit from "../../audit/audit-reducers";
import notifications from "../../notifications/notifications-reducers";
import invoicesStats from "../../home/invoices-stats-reducers";
import deliveryNotesStats from "../../home/delivery-notes-stats-reducers";
import documentation from '../../documentation/documentation-reducers';
import transportation from '../../transportation/transportation-reducers';

const rootReducer = combineReducers({
    // auditLog,
    users,
    invoices,
    deliveryNotes,
    clients,
    executions,
    content,
    technicalsSheets,
    stocks,
    audit,
    notifications,
    invoicesStats,
    deliveryNotesStats,
    documentation,
    transportation
});

export default rootReducer;